import { useEffect, useState } from 'react'

import { CurrentChannel, Message } from '../types/message'
import { axiosInstance } from '../helpers'

export const useChannel = (channelId?: number) => {
    const [messageList, setMessageList] = useState<Message[] | null>(null)
    const [channelDetail, setChannelDetail] = useState<CurrentChannel | null>(
        null,
    )

    const [loadingState, setLoadingState] = useState({
        messageList: false,
        createMessage: false,
        getChannelDetail: false,
    })

    useEffect(() => {
        if (channelId !== -1 && channelId !== undefined) {
            getChannelDetail(channelId)
            getMessages(channelId)
        }

        return () => {
            setMessageList(null)
            setChannelDetail(null)
            setLoadingState({
                messageList: false,
                createMessage: false,
                getChannelDetail: false,
            })
        }
    }, [channelId])

    const getChannelDetail = async (cId: number) => {
        setLoadingState((prev) => {
            return {
                ...prev,
                getChannelDetail: true,
            }
        })

        try {
            const res = await axiosInstance.get(`messaging/channel/${cId}/`)

            setLoadingState((prev) => {
                return {
                    ...prev,
                    getChannelDetail: false,
                }
            })

            setChannelDetail(res.data)

            return res.data
        } catch (e) {
            setLoadingState((prev) => {
                return {
                    ...prev,
                    getChannelDetail: false,
                }
            })

            setChannelDetail(null)
            return Promise.reject(e)
        }
    }

    const getMessages = async (cId: number) => {
        setLoadingState((prev) => {
            return {
                ...prev,
                messageList: true,
            }
        })

        try {
            const res = await axiosInstance.get(
                `messaging/channel/${cId}/messages/`,
            )

            setLoadingState((prev) => {
                return {
                    ...prev,
                    messageList: false,
                }
            })

            setMessageList(res.data)

            return res.data
        } catch (e) {
            setLoadingState((prev) => {
                return {
                    ...prev,
                    messageList: false,
                }
            })
            return Promise.reject(e)
        }
    }

    const createMessage = async (request: FormData) => {
        setLoadingState((prev) => {
            return {
                ...prev,
                createMessage: true,
            }
        })

        try {
            const res = await axiosInstance.post(
                'messaging/create-message/',
                request,
            )

            setLoadingState((prev) => {
                return {
                    ...prev,
                    messageList: false,
                }
            })

            const oldMessageList = messageList ? messageList : []

            setMessageList([...oldMessageList, res.data])

            return res
        } catch (e) {
            setLoadingState((prev) => {
                return {
                    ...prev,
                    messageList: false,
                }
            })
            return Promise.reject(e)
        }
    }

    return {
        channelDetail,
        messageList,
        loadingState,
        createMessage,
    }
}
